document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartInner = document.getElementById('cart-drawer-inner');
    const CROSS_SELL_VIEW_THRESHOLD = 0.5;
    const CROSS_SELL_VIEW_DWELL_MS = 400;

    if (!cartDrawer || !cartInner || !cartOverlay) return;
    const runCartAction = operation => window.aoCartActions.run(operation);
    const loadingStatus = document.getElementById('cart-drawer-loading');
    let loading = false;
    let loadFailed = false;
    let authState = { checking: false, pending: false, failed: false };
    let drawerRefresh;
    let cartContentCurrent = false;

    function updateLoadingState() {
      const busy = loading || authState.checking;
      const blocked = busy || loadFailed || authState.pending || authState.failed;
      cartInner.setAttribute('aria-busy', String(busy));
      if (loadingStatus) {
        loadingStatus.hidden = !busy && !loadFailed;
        loadingStatus.querySelector('[data-cart-loading-message]').textContent =
          busy ? loadingStatus.dataset.loading : loadingStatus.dataset.failed;
        loadingStatus.querySelector('[data-cart-loading-spinner]').hidden = !busy;
        loadingStatus.querySelector('button').hidden = busy || !loadFailed;
      }
      cartDrawer.classList.toggle('is-loading', busy);
      cartDrawer.querySelectorAll('#checkout, [name="checkout"]').forEach(button => {
        if (blocked && !button.disabled) {
          button.dataset.cartLoadingDisabled = 'true';
          button.disabled = true;
        } else if (!blocked && button.dataset.cartLoadingDisabled === 'true') {
          button.disabled = false;
          delete button.dataset.cartLoadingDisabled;
        }
      });
    }

    window.aoCartActions.subscribe(state => {
      authState = state;
      updateLoadingState();
    });
    function guardLoadingCheckout(event) {
      const control = event.submitter || event.target;
      const checkout = control.closest?.('#checkout, [name="checkout"], a[href*="/checkout"]');
      if (!(loading || loadFailed || authState.checking || authState.pending || authState.failed) || !checkout || !cartDrawer.contains(checkout)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    document.addEventListener('click', guardLoadingCheckout, true);
    document.addEventListener('submit', guardLoadingCheckout, true);
    window.aoCartActions.register('cart-drawer', html => {
      if (cartDrawer.classList.contains('open')) {
        const focused = document.activeElement;
        const restoreFocus = cartDrawer.contains(focused);
        const focusedId = focused?.id;
        renderCartContent(html, false);
        if (restoreFocus) (document.getElementById(focusedId) || cartDrawer.querySelector('#cart-drawer-close'))?.focus();
      } else {
        cartContentCurrent = false;
      }
    });
    let listenersAdded = false;
    let freeGiftLockedThisOpen = false;
    let lastFreeShippingStateThisOpen = null;
    let crossSellViewedThisOpen = false;
    let crossSellImpressedThisOpen = false;
    let crossSellViewObserver = null;
    let crossSellViewTimer = null;

    function trackClarityCartEvent(action, detail = {}) {
      if (window.aoClarity && typeof window.aoClarity.trackCartEvent === 'function') {
        window.aoClarity.trackCartEvent(action, detail);
      } else if (typeof window.clarityTrack === 'function') {
        if (action === 'open') {
          const context = normalizeCartOpenContext(detail);
          if (typeof window.clarity === 'function') {
            window.clarity('set', 'cart_surface', context.surface);
            window.clarity('set', 'cart_open_type', context.type);
            window.clarity('set', 'cart_open_source', context.source);
          }

          window.clarityTrack('cart_open');
          return;
        }

        if (action === 'close') {
          if (detail.source && typeof window.clarity === 'function') {
            window.clarity('set', 'cart_close_source', detail.source);
          }

          window.clarityTrack('cart_close');
          return;
        }

        window.clarityTrack(action);
      }
    }

    function getCartStateRoot() {
      return cartDrawer.querySelector('[data-cart-free-shipping-state]');
    }

    function getCartFreeShippingEventName() {
      const stateEl = getCartStateRoot();
      if (!stateEl) return null;

      if (stateEl.dataset.itemCount === '0') {
        return 'cart_emptied';
      }

      if (stateEl.dataset.hasHeavyBulky === 'true') {
        return 'cart_free_shipping_blocked_heavy_bulky';
      }

      if (stateEl.dataset.freeShippingUnlocked === 'true') {
        return 'cart_free_shipping_threshold_met';
      }

      return 'cart_free_shipping_threshold_not_met';
    }

    function getCartFreeShippingState() {
      const stateEl = getCartStateRoot();
      if (!stateEl) return 'not_met';

      if (stateEl.dataset.hasHeavyBulky === 'true') {
        return 'blocked';
      }

      return stateEl.dataset.freeShippingUnlocked === 'true' ? 'met' : 'not_met';
    }

    function getCartValueBand(totalCents) {
      const totalDollars = Math.max(0, Math.floor(Number(totalCents || 0) / 100));

      if (totalDollars >= 400) {
        return '400_plus';
      }

      const lower = Math.floor(totalDollars / 50) * 50;
      const upper = lower + 49;

      return `${lower}_${upper}`;
    }

    function getCartStateTags() {
      const stateEl = getCartStateRoot();
      if (!stateEl) return null;

      const totalCents = Number(stateEl.dataset.cartTotal || 0);
      const itemCount = Number(stateEl.dataset.itemCount || 0);
      const hasCrossSellsNow = Boolean(cartDrawer.querySelector('[data-cart-cross-sell-root]'));

      return {
        surface: 'drawer',
        freeShippingState: getCartFreeShippingState(),
        valueBand: getCartValueBand(totalCents),
        itemCount,
        total: (totalCents / 100).toFixed(2),
        hasCrossSells: hasCrossSellsNow,
        hasHeavyBulky: stateEl.dataset.hasHeavyBulky === 'true',
        hasDropship: stateEl.dataset.hasDropship === 'true',
        pricingMix: stateEl.dataset.cartPricingMix || 'full_price'
      };
    }

    function setClarityCartStateTags() {
      const tags = getCartStateTags();
      if (!tags) return;

      if (window.aoClarity && typeof window.aoClarity.setCartState === 'function') {
        window.aoClarity.setCartState(tags);
      } else if (typeof window.clarity === 'function') {
        window.clarity('set', 'cart_surface', tags.surface);
        window.clarity('set', 'cart_free_shipping_state', String(tags.freeShippingState));
        window.clarity('set', 'cart_value_band', String(tags.valueBand));
        window.clarity('set', 'cart_item_count', String(tags.itemCount));
        window.clarity('set', 'cart_total', String(tags.total));
        window.clarity('set', 'cart_has_cross_sells', String(tags.hasCrossSells));
        window.clarity('set', 'cart_has_heavy_bulky', String(tags.hasHeavyBulky));
        window.clarity('set', 'cart_has_dropship', String(tags.hasDropship));
        window.clarity('set', 'cart_pricing_mix', String(tags.pricingMix));
      }
    }

    function trackClarityCartState() {
      const eventName = getCartFreeShippingEventName();
      if (!eventName) return;

      if (lastFreeShippingStateThisOpen === null) {
        lastFreeShippingStateThisOpen = eventName;
        return;
      }

      if (lastFreeShippingStateThisOpen === eventName) return;

      lastFreeShippingStateThisOpen = eventName;

      if (window.aoClarity && typeof window.aoClarity.trackCartDrawerState === 'function') {
        window.aoClarity.trackCartDrawerState(cartDrawer);
      } else if (typeof window.clarityTrack === 'function') {
        window.clarityTrack(eventName);
      }
    }

    function normalizeCartOpenContext(context = {}) {
      return {
        surface: 'drawer',
        type: context.type || 'unknown',
        source: context.source || 'unknown'
      };
    }

    function trackCartDrawerOpen(context = {}) {
      if (context.track === false) return;

      trackClarityCartEvent('open', normalizeCartOpenContext(context));
    }

    function openCartDrawer(context = {}) {
        const wasOpen = cartDrawer.classList.contains('open');

        freeGiftLockedThisOpen = false;
        if (!wasOpen) {
          lastFreeShippingStateThisOpen = null;
          crossSellViewedThisOpen = false;
          crossSellImpressedThisOpen = false;
        }

        // Add cart event listener
        addEventListeners();

        // Drop chat button z-index
        const gorgiasBtn = document.getElementById('chat-button');
        if (gorgiasBtn) gorgiasBtn.style.zIndex = '1';

        loading = true;
        loadFailed = false;
        updateLoadingState();

        // Show drawer and overlay immediately
        cartDrawer.classList.add('open');
        cartOverlay.classList.remove('hidden');
        cartOverlay.classList.add('visible');
        document.body.classList.add('no-scroll');

        if (!wasOpen) {
          trackCartDrawerOpen(context);
        }

        if (!drawerRefresh) {
          drawerRefresh = (context.type === 'manual'
            ? window.aoCartActions.check().then(refreshed => {
                if (!refreshed || !cartContentCurrent) return fetchCartContent();
              }).catch(() => fetchCartContent())
            : fetchCartContent())
            .catch(() => { loadFailed = true; })
            .finally(() => {
              drawerRefresh = undefined;
              loading = false;
              updateLoadingState();
            });
        }
        return drawerRefresh;
    }
    loadingStatus?.querySelector('button').addEventListener('click', () => openCartDrawer({ type: 'manual', track: false }));
    window.openCartDrawer = openCartDrawer; // Expose function globally. Used in cart-notification.js to open the drawer.
    
    function closeCartDrawer(context = {}) {
        const wasOpen = cartDrawer.classList.contains('open');

        if (wasOpen && context.source) {
          trackClarityCartEvent('close', { source: context.source });
        }

        cartDrawer.classList.remove('open');
        cartOverlay.classList.remove('visible');
        cartOverlay.classList.add('hidden');
        disconnectCrossSellViewObserver();

        document.body.classList.remove('no-scroll');
        // Restore chat button z-index
        const gorgiasBtn = document.getElementById('chat-button');
        if (gorgiasBtn) gorgiasBtn.style.zIndex = '2147483636';
    }

    function fetchCartContent() {
      return runCartAction(() => fetch(window.Shopify.routes.root + '?section_id=cart-drawer', { cache: 'no-store' })
        .then(res => res.text())
        .then(html => renderCartContent(html)));
    }

    function renderCartContent(html, focusCheckout = true) {

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.getElementById('shopify-section-cart-drawer');
      if (!content) throw new Error('Cart drawer section unavailable');

      // Inject cart content
      cartInner.innerHTML = content.innerHTML;
      cartContentCurrent = true;
      updateLoadingState();

      setTimeout(() => {
        document.querySelectorAll('.cart-drawer__cross-sells-wrapper')
          .forEach(wrapper => updateCrossSellNavState(wrapper));
      }, 50);

      // Auto-focus checkout button and init shipping
      const checkoutBtn = cartDrawer.querySelector('#checkout');
      if (checkoutBtn) {
        if (focusCheckout && cartDrawer.classList.contains('open')) cartDrawer.querySelector('#cart-drawer-close')?.focus();
        //initShippingCalculator();
        initFreeGiftOffers();
      }

      updateCartIconCount();
      setClarityCartStateTags();
      trackClarityCartState();
      trackCartCrossSellImpression();
      observeCartCrossSellView();
    }

    function trackCartCrossSellImpression() {
      if (crossSellImpressedThisOpen) return;

      const crossSellRoot = cartDrawer.querySelector('[data-cart-cross-sell-root]');
      if (!crossSellRoot) return;

      crossSellImpressedThisOpen = true;
      trackClarityCartEvent('cross_sell_impression');
    }

    function disconnectCrossSellViewObserver() {
      clearCrossSellViewTimer();

      if (!crossSellViewObserver) return;

      crossSellViewObserver.disconnect();
      crossSellViewObserver = null;
    }

    function clearCrossSellViewTimer() {
      if (!crossSellViewTimer) return;

      clearTimeout(crossSellViewTimer);
      crossSellViewTimer = null;
    }

    function startCrossSellViewTimer() {
      if (crossSellViewTimer || crossSellViewedThisOpen) return;

      crossSellViewTimer = setTimeout(() => {
        crossSellViewTimer = null;
        if (crossSellViewedThisOpen) return;

        crossSellViewedThisOpen = true;
        trackClarityCartEvent('cross_sell_view');
        disconnectCrossSellViewObserver();
      }, CROSS_SELL_VIEW_DWELL_MS);
    }

    function observeCartCrossSellView() {
      disconnectCrossSellViewObserver();

      if (crossSellViewedThisOpen) return;

      const crossSellRoot = cartDrawer.querySelector('[data-cart-cross-sell-root]');
      if (!crossSellRoot) return;

      if (typeof IntersectionObserver !== 'function') {
        crossSellViewedThisOpen = true;
        trackClarityCartEvent('cross_sell_view');
        return;
      }

      crossSellViewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (crossSellViewedThisOpen) return;

          if (entry.isIntersecting && entry.intersectionRatio >= CROSS_SELL_VIEW_THRESHOLD) {
            startCrossSellViewTimer();
          } else {
            clearCrossSellViewTimer();
          }
        });
      }, {
        root: cartDrawer,
        threshold: CROSS_SELL_VIEW_THRESHOLD
      });

      crossSellViewObserver.observe(crossSellRoot);
    }
    
    function updateCartIconCount() {
      const countBubble = document.querySelector('.cart-count-bubble');
      if (!countBubble) return;

      let count = 0;
      const subtotalRow = document.querySelector('.cart-drawer__row--subtotal');
      if (subtotalRow) {
        // Get items count from the subtotal row
        count = subtotalRow.dataset.itemsCount || 0;
      } 

      const spanVisible = countBubble.querySelector('span[aria-hidden="true"]');
      const spanScreenReader = countBubble.querySelector('span.visually-hidden');

      if (spanVisible) spanVisible.innerText = count;
      if (spanScreenReader) spanScreenReader.innerText = `${count} item${count === 1 ? '' : 's'}`;
    
    }

    // Bind to cart icon
    const cartTrigger = document.querySelector('[data-drawer-toggle="cart"]');
    if (cartTrigger) {
        cartTrigger.addEventListener('click', function (e) {
            const cartUrl = new URL(cartTrigger.href, window.location.origin);
            const normalizePath = (path) => path.replace(/\/$/, '') || '/';
            const isCartPage = normalizePath(window.location.pathname) === normalizePath(cartUrl.pathname);

            if (isCartPage) {
              e.preventDefault();
              window.location.reload();
              return;
            }

            e.preventDefault();
            openCartDrawer({ type: 'manual', source: 'header' });
        });
    }

    function addEventListeners() {
      if (listenersAdded) return;
      listenersAdded = true;

      // Overlay click closes drawer
      cartOverlay.addEventListener('click', () => closeCartDrawer({ source: 'overlay' }));

      // Header close button click closes drawer
      document.addEventListener('click', function (e) {
          const checkoutBtn = e.target.closest('#checkout, .cart__checkout-button, [name="checkout"]');
          if (checkoutBtn && cartDrawer.contains(checkoutBtn)) {
              setClarityCartStateTags();
              trackClarityCartEvent('checkout');
              return;
          }

          if (e.target.id === 'cart-drawer-close') {
              closeCartDrawer({ source: 'icon' });
          }
      });

      // ESC key closes drawer
      document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && cartDrawer.classList.contains('open')) {
              closeCartDrawer();
          }
      });

      // Trap focus inside cart drawer when open
      document.addEventListener('keydown', function (e) {
          if (!cartDrawer.classList.contains('open')) return;

          const focusableSelectors = [
              'a[href]',
              'button:not([disabled])',
              'textarea:not([disabled])',
              'input:not([disabled])',
              'select:not([disabled])',
              '[tabindex]:not([tabindex="-1"])'
          ];
          const focusableElements = cartDrawer.querySelectorAll(focusableSelectors.join(', '));
          if (focusableElements.length === 0) return;

          const first = focusableElements[0];
          const last = focusableElements[focusableElements.length - 1];

          // Trap Tab key
          if (e.key === 'Tab') {
              if (e.shiftKey && document.activeElement === first) {
                  e.preventDefault();
                  last.focus();
              } else if (!e.shiftKey && document.activeElement === last) {
                  e.preventDefault();
                  first.focus();
              }
          }
      });

      // Handle remove item clicks
      document.addEventListener('click', function (e) {
        const removeBtn = e.target.closest('.cart-drawer__remove');
        if (!removeBtn) return;

        e.preventDefault();
        removeBtn.classList.add('cart-drawer__remove--loading');

        const line = removeBtn.getAttribute('data-line');
        const item = removeBtn.closest('.cart-drawer__item');
        const trackingDetail = {
          line: Number(line),
          variantId: removeBtn.dataset.variantId || item?.dataset.variantId,
          sku: removeBtn.dataset.sku || item?.dataset.sku,
          productTitle: removeBtn.dataset.productTitle || item?.dataset.title,
          quantity: Number(item?.dataset.quantity || 0)
        };

        // Disable all remove buttons
        document.querySelectorAll('.cart-drawer__remove').forEach(btn => btn.disabled = true);

        runCartAction(() => fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: 0 })
        })
          .then(res => res.json())
          .then(() => {
            trackClarityCartEvent('remove', trackingDetail);
            fetchCartContent();
            document.querySelectorAll('.cart-drawer__remove').forEach(btn => btn.disabled = false);
          }));
      });

      // Handle quantity changes
      document.addEventListener('change', function (e) {
          if (e.target.matches('.cart-drawer__quantity-select')) {
              const line = e.target.getAttribute('data-line');
              const previousQuantity = parseInt(e.target.dataset.currentQuantity || '0', 10);
              const quantity = parseInt(e.target.value, 10);
              const direction = quantity > previousQuantity ? 'increase' : quantity < previousQuantity ? 'decrease' : 'change';
              const item = e.target.closest('.cart-drawer__item');
              const trackingDetail = {
                line: Number(line),
                previousQuantity,
                quantity,
                direction,
                variantId: e.target.dataset.variantId || item?.dataset.variantId,
                sku: e.target.dataset.sku || item?.dataset.sku,
                productTitle: e.target.dataset.productTitle || item?.dataset.title
              };

              runCartAction(() => fetch(window.Shopify.routes.root + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ line: Number(line), quantity: quantity })
              })
                  .then(res => res.json())
                  .then(() => {
                      trackClarityCartEvent('quantity', trackingDetail);
                      // Refresh cart drawer
                      fetchCartContent();
                  }));
          }
      });

      // Order references
      document.addEventListener('click', function (e) {
        if (e.target.matches('.edit-order-reference')) {
          e.preventDefault();
          const itemKey = e.target.getAttribute('data-order-ref-key');
          const currentReference = e.target.getAttribute('data-order-ref-value') || '';

          editOrderReference(itemKey, currentReference);
        }
      });
      function editOrderReference(...args) {
        return runCartAction(() => performEditOrderReference(...args));
      }
      async function performEditOrderReference(itemKey, currentReference) {
          const input = prompt("Add, edit or remove your order reference(s):", currentReference);
          if (input === null) {
              // User cancelled the prompt, do nothing
              return;
          }

          const newReference = input?.trim();

          // Fetch the cart to get the line item by key
          const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json());
          const lineItem = cart.items.find(item => item.key === itemKey);
          if (!lineItem) {
              return;
          }

          const existingProperties = { ...(lineItem.properties || {}) };
          if (!newReference || newReference === '') {
              existingProperties['Order Reference(s)'] = "";
          } else {
              existingProperties['Order Reference(s)'] = newReference;
          }

          //console.log('Existing properties:', JSON.stringify(existingProperties, null, 2));

          const updates = {'id': itemKey, 'quantity': lineItem.quantity, 'properties': existingProperties};

          // Perform the fetch request
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(updates)
          })
          .then(response => {
              if (response.ok) {
                  return response.json();
              } else {
                  throw new Error(`Cart line item properties update failed. ${response.statusText} ${response.status}`);
              }
          })
          .then((data) => {
              openCartDrawer({ track: false }); // Refresh the cart drawer
          })
          .catch((error) => {
              console.error('Error:', error, JSON.stringify(updates));
          });
      }

      // Postcode input & change event
      document.addEventListener('input', function (e) {
        if (e.target.matches('.cart-drawer__postcode-input')) {
          // Handle input event for postcode
          e.target.value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
          if (e.target.value.length > 4) {
            e.target.value = e.target.value.slice(0, 4); // Limit to 4 characters
          }
        }
      });

      document.addEventListener('change', async function (e) {
        if (e.target.matches('.cart-drawer__postcode-input')) {
          e.preventDefault();

          const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
          if (shippingCost) {
            shippingCost.classList.add('shimmer');  
            shippingCost.innerText = '&nbsp;'; // Show shimmer effect}
          }
          
          // Handle change event for postcode
          const postcode = e.target.value;

          // Save postcode to local storage
          address.zip = postcode;
          address.city = null; // Reset city as postcode has changed
          address.province = null; // Reset province as postcode has changed
          address.country = null; // Reset country as postcode has changed  

          await getPostcodeDetails(postcode);
          addressIsComplete = () => address.city?.trim() && address.zip?.trim() && address.province?.trim() && address.country?.trim();
          if (addressIsComplete()) {
            getShippingRates(address);
          } 
          else {
            // Display postcode input box
            document.querySelector('.cart-drawer__row--shipping-postcode').classList.remove('hidden');
            const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
            if (shippingCost) {
              shippingCost.classList.remove('shimmer');  
              shippingCost.innerText = 'Enter a valid postcode';
              renderRates([]); // Clear rates display
            }
          }
        }
      });

      // 🚀 ENTER key triggers 'change' manually
      document.addEventListener('keydown', function (e) {
        if (e.target.matches('.cart-drawer__postcode-input') && e.key === 'Enter') {
          e.preventDefault();
          const changeEvent = new Event('change', { bubbles: true });
          e.target.dispatchEvent(changeEvent);
        }
      });

      document.addEventListener('click', async function (e) {
        const btn = e.target.closest('[data-cross-sell-add]');
        if (!btn) return;

        e.preventDefault();

        if (btn.classList.contains('is-loading') || btn.disabled) return;

        btn.classList.add('is-loading');

        try {
          await addCrossSellVariant(btn.dataset.variantId, btn.dataset.crossSellPosition);
          trackClarityCartEvent('cross_sell_atc', {
            variantId: btn.dataset.variantId,
            position: btn.dataset.crossSellPosition || 'card'
          });
          fetchCartContent(); // Re-render cart drawer so item disappears from cross-sells
        } catch (error) {
          console.error('Cross-sell add failed', error);
          btn.classList.remove('is-loading');
        }
      });
      document.addEventListener('click', function (e) {
        const nav = e.target.closest('[data-cross-sell-nav]');
        if (!nav) return;
        const direction = nav.dataset.crossSellNav;
        const wrapper = nav.closest('.cart-drawer__cross-sells-wrapper');
        if (!wrapper) return;
        const track = wrapper.querySelector('[data-cross-sell-track]');
        if (!track) return;

        // Scroll amount = ~1 card width
        const card = track.querySelector('.cart-drawer__cross-sell-card');
        if (!card) return;

        const scrollAmount = card.offsetWidth + 12; // 12 = gap

        if (direction === 'right') {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }

        trackClarityCartEvent('cross_sell_nav', { direction });
      });
      document.addEventListener('scroll', function (e) {
        if (!(e.target instanceof Element)) return;

        const track = e.target.closest('[data-cross-sell-track]');
        if (!track) return;

        const wrapper = track.closest('.cart-drawer__cross-sells-wrapper');
        if (!wrapper) return;

        updateCrossSellNavState(wrapper);
      }, true);

    }

    ////////////////////////////////////////////////////////
    // Free Gift – show offer when eligible, add on click
    ////////////////////////////////////////////////////////
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function eligibleSubtotalCents(cart, excludedVariantId) {
      return cart.items.reduce((sum, item) => {
        if (Number(item.variant_id) === Number(excludedVariantId)) return sum;
        return sum + item.final_line_price; // cents
      }, 0);
    }

    function normalizeDiscountTitle(title) {
      return String(title || '').trim().toLowerCase();
    }

    function nonStackableDiscountTitles(offer) {
      const freeGiftWrapper = offer.closest('[data-free-gifts]');
      const rawTitles = freeGiftWrapper?.dataset.nonStackableDiscounts || '';

      return rawTitles
        .split(/[\n,]+/)
        .map(normalizeDiscountTitle)
        .filter(Boolean);
    }

    function appliedDiscountTitles(cart) {
      const titles = [];

      cart.cart_level_discount_applications?.forEach(discount => {
        titles.push(discount.title);
      });

      cart.items?.forEach(item => {
        item.line_level_discount_allocations?.forEach(allocation => {
          titles.push(allocation.discount_application?.title);
        });

        item.discounts?.forEach(discount => {
          titles.push(discount.title);
        });
      });

      return titles.map(normalizeDiscountTitle).filter(Boolean);
    }

    function hasNonStackableDiscountApplied(cart, offer) {
      const blockedTitles = nonStackableDiscountTitles(offer);
      if (!blockedTitles.length) return false;

      const activeTitles = appliedDiscountTitles(cart);
      return activeTitles.some(title => blockedTitles.includes(title));
    }

    async function fetchCartJson() {
      const res = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    }

    function addGiftVariant(...args) {
      return runCartAction(() => performAddGiftVariant(...args));
    }

    async function performAddGiftVariant(variantId) {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.warn('Gift could not be added:', err);
      }
    }

    async function updateFreeGiftOffersUI() {
      const offer = cartDrawer.querySelector('[data-free-gift-offer]');
      if (!offer) return;

      const variantId = Number(offer.dataset.variantId);
      const thresholdCents = Number(offer.dataset.minSpendCents);

      const headerPre = offer.querySelector('[data-free-gift-header-pre]');
      const headerUnlocked = offer.querySelector('[data-free-gift-header-unlocked]');
      const remainingEl = offer.querySelector('[data-free-gift-remaining]');
      const btn = offer.querySelector('[data-free-gift-accept]');

      const cart = await fetchCartJson();
      const subtotal = eligibleSubtotalCents(cart, variantId);
      const eligible = subtotal >= thresholdCents;
      const hasGift = cart.items.some(i => Number(i.variant_id) === variantId);
      const hasBlockedDiscount = hasNonStackableDiscountApplied(cart, offer);

      if (hasGift || hasBlockedDiscount) {
        offer.classList.add('hidden');
        return;
      }

      offer.classList.remove('hidden');

      if (eligible) {
        // ✅ UNLOCKED
        headerPre?.classList.add('hidden');
        headerUnlocked?.classList.remove('hidden');

        if (btn) {
          btn.classList.remove('is-hidden');
          btn.disabled = false;
        }
      } else {
        // 🔒 PRE‑UNLOCK
        headerUnlocked?.classList.add('hidden');
        headerPre?.classList.remove('hidden');

        if (btn) {
          btn.classList.add('is-hidden');
          btn.disabled = true;
        }

        const remaining = Math.max(0, thresholdCents - subtotal);
        if (remainingEl) remainingEl.textContent = formatMoney(remaining);
      }
    }

    function initFreeGiftOffers() {
      const offer = cartDrawer.querySelector('[data-free-gift-offer]');
      if (!offer) return;

      const btn = offer.querySelector('[data-free-gift-accept]');
      if (btn && !btn.dataset.bound) {
        btn.dataset.bound = 'true';

        btn.addEventListener('click', async () => {
          if (btn.classList.contains('is-loading') || btn.disabled) return;

          btn.classList.add('is-loading');

          try {
            await addGiftVariant(offer.dataset.variantId);
            fetchCartContent(); // re-render → free gift block disappears
          } catch (e) {
            console.error('Free gift add failed', e);
            btn.classList.remove('is-loading');
          }
        });
      }

      // ✅ THIS IS THE MISSING PIECE
      updateFreeGiftOffersUI();
    }

    ////////////////////////////////////////////////////////
    // Cross-sell offers – show offer when eligible, add on click
    ////////////////////////////////////////////////////////
    function addCrossSellVariant(...args) {
      return runCartAction(() => performAddCrossSellVariant(...args));
    }

    async function performAddCrossSellVariant(variantId, position) {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: {
                _cart_upsell: `position:${position}`
              }
            }
          ]
        })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.warn('Cross-sell could not be added:', err);
        throw new Error('Cross-sell add failed');
      }

      return res.json();
    }


    function updateCrossSellNavState(wrapper) {
      const track = wrapper.querySelector('[data-cross-sell-track]');
      const leftBtn = wrapper.querySelector('[data-cross-sell-nav="left"]');
      const rightBtn = wrapper.querySelector('[data-cross-sell-nav="right"]');
      const leftFade = wrapper.querySelector('.cross-sell-fade--left');
      const rightFade = wrapper.querySelector('.cross-sell-fade--right');

      if (!track || !leftBtn || !rightBtn) return;

      const scrollLeft = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;

      const atStart = scrollLeft <= 5;
      const atEnd = scrollLeft >= maxScroll - 5;
      const hasOverflow = track.scrollWidth > track.clientWidth;

      /* Arrow states */
      leftBtn.classList.toggle('is-disabled', atStart);
      rightBtn.classList.toggle('is-disabled', atEnd);

      /* Fade states */
      if (leftFade) {
        leftFade.classList.toggle('is-visible', hasOverflow && !atStart);
      }

      if (rightFade) {
        rightFade.classList.toggle('is-visible', hasOverflow && !atEnd);
      }

      /* Hide arrows if there is nothing to scroll */
      if (!hasOverflow) {
        leftBtn.style.display = 'none';
        rightBtn.style.display = 'none';
      } else {
        leftBtn.style.display = '';
        rightBtn.style.display = '';
      }
    }

});
